import { mcToast } from '@/plugins/McToastAlertPlugin'
const toast = mcToast

const IGNORED_PATHS_500 = ['route-optimization']

const isPathIncluded = (pathList) => {
  const currentPath = window.location.pathname
  return pathList.some((path) => currentPath.includes(path))
}

const errorHandlerRest = (e) => {
  let errors = true

  switch (e?.response?.status) {
    case 401:
      // TODO: probably need to adjust this since we are using cookies for auth
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    case 400:
      if (e.response.data?.message === 'bad_request') {
        toast.error('Terdapat kesalahan format pada input anda')
      }

      // So usage will be:
      // const res = await FleetTask.get()
      // if(res.errors) /* do error handling */
      // else /* do something else */

      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 403:
    case 404:
      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 500:
      toast.error('Internal Server Error')
      break

    default:
      console.error(e)
      toast.error(`${e.response?.status} ${e.response?.data || e.message}`)
  }
}

function readBlobAsText(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      try {
        const errorData = JSON.parse(reader.result)
        resolve(errorData.message) // Resolve with the message property
      } catch (error) {
        reject(error) // Reject the promise if there's an error parsing
      }
    }
    reader.onerror = reject
    reader.readAsText(blob)
  })
}

/*
 * NOTE:
 * errorHandlerRestV2 is created since we need to handle toast message from
 * parent completely, since errorHandlerRest (v1) is used in existing code,
 * removing the toast message will break the existing code.
 */
export const errorHandlerRestV2 = (e) => {
  let errors = true
  const pathName = window.location.pathname.split('/')

  switch (e?.response?.status) {
    case 401:
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    // So usage will be:
    // const res = await FleetTask.get()
    // if(res.errors) /* do error handling */
    // else /* do something else */
    case 400:
      if (pathName.includes('fleet-task') && pathName.includes('track')) {
        const data = {
          hasButton: false,
        }
        localStorage.setItem('404', JSON.stringify(data))
        window.location.href = '/404'
      } else {
        errors = e.response?.data?.errors ?? errors
        var errors_v2 = e.response?.data?.errors_v2 ?? errors

        return Promise.resolve({
          data: {
            errors,
            errors_v2,
            status: e.response.status,
            message: e.response.data?.message,
          },
        })
      }
      break
    case 403:
    case 404:
    case 422:
      if (e.response?.config?.responseType === 'blob') {
        const errorBlob = e.response.data
        // Wait for the readBlobAsText to resolve before continuing
        return readBlobAsText(errorBlob).then((message) => {
          return {
            data: {
              errors: e.response?.data?.errors ?? errors,
              status: e.response.status,
              message,
            },
          }
        })
      }
      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
          message: e.response.data?.message,
        },
      })

    case 500: {
      const config = e.response?.config || e.config
      const url = config?.url || ''

      if (isPathIncluded(IGNORED_PATHS_500)) {
        if (url.includes('/movement')) {
          return Promise.resolve({
            data: {
              errors,
              status: e.response.status,
            },
          })
        } else {
          toast.error('Internal Server Error')
        }
      } else {
        toast.error('Internal Server Error')
      }

      break
    }

    default:
      console.error(e)

      toast.error(`${e.response?.status} ${e.response?.data || e.message}`)
      return Promise.resolve({
        data: {
          errors: e.response?.data ?? errors,
          status: e.response.status,
        },
      })
  }
}

export default errorHandlerRest
